import http from '@/utils/services/http'

export default {
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/pregao/leilao/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  abrir (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + id + '/abrir') // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  mudarLote (id, numero) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + id + '/mudarLote?numero=' + numero) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  avancarLote (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + id + '/avancarLote') // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  voltarLote (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + id + '/voltarLote') // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  deletarLance (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.delete('/api/lance/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  alteraStatusLote (leilao, lote, data) {
    console.log(data)
    leilao = parseInt(leilao)
    if (leilao < 1) return Promise.reject()
    lote = parseInt(lote)
    if (lote < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + leilao + '/' + lote + '/status', data) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  lancePlateia (leilao, lote, valor) {
    valor = typeof valor === 'undefined' ? 0 : valor
    leilao = parseInt(leilao)
    if (leilao < 1) return Promise.reject()
    lote = parseInt(lote)
    if (lote < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + leilao + '/' + lote + '/plateia/lance', {valor: valor}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  alteraIncrementoMinimo (leilao, lote, valor) {
    leilao = parseInt(leilao)
    if (leilao < 1) return Promise.reject()
    lote = parseInt(lote)
    if (lote < 1) return Promise.reject()
    return http.patch('/api/pregao/leilao/' + leilao + '/' + lote + '/alterarIncremento', {valor: valor}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  alteraTimer (leilao, valor) {
    leilao = parseInt(leilao)
    if (leilao < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + leilao + '/timer', {valor: valor}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  getLancePrincipal (lote) {
    lote = parseInt(lote)
    if (lote < 1) return Promise.reject()
    return http.get('/api/lote/' + lote + '/lancePrincipal') // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  renovaTempoPregaoLote (leilao, lote, status) {
    leilao = parseInt(leilao)
    if (leilao < 1) return Promise.reject()
    lote = parseInt(lote)
    if (lote < 1) return Promise.reject()
    return http.post('/api/pregao/leilao/' + leilao + '/' + lote + '/renovarTempo', {status: status}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  getStatsPregao (leilao) {
    leilao = parseInt(leilao)
    if (leilao < 1) return Promise.reject()
    return http.get('/api/pregao/leilao/' + leilao + '/stats')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  getAllLotes (leilao) {
    leilao = parseInt(leilao)
    if (leilao < 1) return Promise.reject()
    return http.get('/api/public/leilao/' + leilao + '/all')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  videos (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/pregao/leilao/' + id + '/videos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/pregao.js